import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getOrder, getOrders, GetOrdersParams, getOrdersTotal } from '../clients/gateway.api';

interface QuickFilterTotalsParams {
    searchQuery?: string;
    customerIds?: string[];
    supplierIds?: string[];
    tab?: string;
    quickFilter?: string;
}

interface OrderTotalsParams {
    searchQuery?: string;
    customerIds?: string[];
    supplierIds?: string[];
    tab: string;
    offerStates: string[] | string;
    states: string[] | string;
}

export const orders = createQueryKeys('orders', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getOrder(id),
    }),
    pagination: (params: GetOrdersParams) => ({
        queryKey: [{ params }],
        queryFn: () => getOrders(params),
    }),
    comboBoxOptions: (params: GetOrdersParams) => ({ queryKey: [{ params }] }),
    selectedComboBoxOption: (orderId: string) => ({ queryKey: [{ orderId }] }),
    quickFilterTotals: (params: QuickFilterTotalsParams) => ({
        queryKey: [{ params }],
    }),
    totals: (params: OrderTotalsParams) => ({
        queryKey: [{ params }],
        queryFn: () =>
            getOrdersTotal({
                searchQuery: params.searchQuery,
                customerIds: params.customerIds,
                supplierIds: params.supplierIds,
                offerStates: params.offerStates,
                states: params.states,
            }),
    }),
});
